import React from 'react';
import {Link} from 'react-router';
import {getVideoUrl, getDance} from './AppUtils';
import Moment from 'react-moment';
import FullscreenView from './FullscreenView';

class Dance extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            mounted: false,
            id: null,
            name: null,
            when: null,
            numVideos: 1,
            video1: null,
            video1_image: null,
            video1_caption: null,
            video1_ready: false,
            video2: null,
            video2_caption: null,
            video2_image: null,
            video2_ready: false,
            video3: null,
            video3_caption: null,
            video3_image: null,
            video3_ready: false,
            video4_caption: null,
            video4: null,
            video4_image: null,
            video4_ready: false,
            video5: null,
            video5_image: null,
            video5_caption: null,
            video5_ready: false,
            play: false,
            respond: true,
            fullscreenVideo: null,
        };

        this.setVideoLoop = this.setVideoLoop.bind(this);
        this.setupInstance = this.setupInstance.bind(this);
        this.togglePlay = this.togglePlay.bind(this);
        this.playVideos = this.playVideos.bind(this);
        this.getCaption = this.getCaption.bind(this);

        this.restartAll = this.restartAll.bind(this);
    }

    componentDidMount() {
        //if(this.props.respond) {
        this.setState({respond: this.props.respond});
        //}


        if (!this.props.browse) {
            getDance(this.props.danceId)
                .then((success) => {
                    if (success.success) {
                        var data = success.data;
                        this.setupInstance(data);
                    }
                });
        } else {
            this.setupInstance(this.props.dance);
        }
    }

    getCaption(d) {
        var caption = "";
        if (d.dancerName && d.dancerLocation) {
            caption = d.dancerName + " / " + d.dancerLocation;
        } else {
            if (d.dancerName) {
                caption = d.dancerName;
            }

            if (d.dancerLocation) {
                caption = d.dancerLocation;
            }
        }

        return caption;
    }

    setupInstance(data) {
        var video1 = null, video2 = null, video3 = null, video4 = null, video5 = null;
        var video1_image = null, video2_image = null, video3_image = null, video4_image = null, video5_image = null;
        var video1_caption = null, video2_caption = null, video3_caption = null, video4_caption = null,
            video5_caption = null;

        if (data.dances[0]) {
            video1 = getVideoUrl() + data.dances[0].id + ".webm";
            video1_image = getVideoUrl() + data.dances[0].id + ".jpeg";
            video1_caption = this.getCaption(data.dances[0]);
        }

        if (data.dances[1]) {
            video2 = getVideoUrl() + data.dances[1].id + ".webm";
            video2_image = getVideoUrl() + data.dances[1].id + ".jpeg";
            video2_caption = this.getCaption(data.dances[1]);
        }

        if (data.dances[2]) {
            video3 = getVideoUrl() + data.dances[2].id + ".webm";
            video3_image = getVideoUrl() + data.dances[2].id + ".jpeg";
            video3_caption = this.getCaption(data.dances[2]);
        }

        if (data.dances[3]) {
            video4 = getVideoUrl() + data.dances[3].id + ".webm";
            video4_image = getVideoUrl() + data.dances[3].id + ".jpeg";
            video4_caption = this.getCaption(data.dances[3]);
        }

        if (data.dances[4]) {
            video5 = getVideoUrl() + data.dances[4].id + ".webm";
            video5_image = getVideoUrl() + data.dances[4].id + ".jpeg";
            video5_caption = this.getCaption(data.dances[4]);
        }

        this.setState({
            name: data.name,
            when: data.updated_at,
            id: data._id,
            video1: video1,
            video2: video2,
            video3: video3,
            video4: video4,
            video5: video5,
            video1_image: video1_image,
            video2_image: video2_image,
            video3_image: video3_image,
            video4_image: video4_image,
            video5_image: video5_image,
            video1_caption: video1_caption,
            video2_caption: video2_caption,
            video3_caption: video3_caption,
            video4_caption: video4_caption,
            video5_caption: video5_caption,
            play: this.props.play,
            mounted: true
        }, function () {
            if (this.props.play) {
                this.playVideos();
            }

        });
    }

    playVideos() {
        var numVideos = 0;

        if (this.state.video1) {
            this.setVideoLoop(this.refs.video1, this.state.video1, 1);
            if (this.state.play) {
                this.refs.video1.oncanplaythrough = function () {
                    //console.log("video 1 ready");
                    this.setState({
                        "video1_ready": true
                    });
                }.bind(this);

                this.refs.video1.oncanplaythrough = function () {
                    this.setState({
                        "video1_ready": true
                    });
                }.bind(this);
            }
            numVideos++;

        }

        if (this.state.video2) {
            this.setVideoLoop(this.refs.video2, this.state.video2, 2);
            if (this.state.play) {
                this.refs.video2.oncanplaythrough = function () {
                    this.setState({
                        "video2_ready": true
                    });
                }.bind(this);
            }

            numVideos++;
        }

        if (this.state.video3) {
            this.setVideoLoop(this.refs.video3, this.state.video3, 3);
            if (this.state.play) {
                this.refs.video3.oncanplaythrough = function () {
                    this.setState({
                        "video3_ready": true
                    });
                }.bind(this);
            }
            numVideos++;
        }

        if (this.state.video4) {
            this.setVideoLoop(this.refs.video4, this.state.video4, 4);
            if (this.state.play) {
                this.refs.video4.oncanplaythrough = function () {
                    this.setState({
                        "video4_ready": true
                    });
                }.bind(this);
            }
            numVideos++;
        }

        if (this.state.video5) {
            this.setVideoLoop(this.refs.video5, this.state.video5, 5);
            if (this.state.play) {
                this.refs.video5.oncanplaythrough = function () {
                    this.setState({
                        "video5_ready": true
                    });
                }.bind(this);
            }
            numVideos++;
        }

        // setup timer here to make sure every video is loaded
        this.setState({
            numVideos: numVideos,
            videoInterval: setInterval(function () {
                switch (numVideos) {
                    case 1:
                        if (this.state.video1_ready) {
                            this.refs.video1.play();
                            clearInterval(this.state.videoInterval);
                        }
                        break;
                    case 2:
                        if (this.state.video1_ready && this.state.video2_ready) {
                            this.refs.video1.play();
                            this.refs.video2.play();
                            clearInterval(this.state.videoInterval);
                        }
                        break;
                    case 3:
                        if (this.state.video1_ready && this.state.video2_ready && this.state.video3_ready) {
                            this.refs.video1.play();
                            this.refs.video2.play();
                            this.refs.video3.play();
                            clearInterval(this.state.videoInterval);
                        }
                        break;
                    case 4:
                        if (this.state.video1_ready && this.state.video2_ready && this.state.video3_ready && this.state.video4_ready) {
                            this.refs.video1.play();
                            this.refs.video2.play();
                            this.refs.video3.play();
                            this.refs.video4.play();
                            clearInterval(this.state.videoInterval);
                        }
                        break;

                    case 5:
                        if (this.state.video1_ready
                            && this.state.video2_ready
                            && this.state.video3_ready
                            && this.state.video4_ready
                            && this.state.video5_ready) {
                            this.refs.video1.play();
                            this.refs.video2.play();
                            this.refs.video3.play();
                            this.refs.video4.play();
                            this.refs.video5.play();
                            clearInterval(this.state.videoInterval);
                        }
                        break;
                }

            }.bind(this), 100)
        });

    }

    setVideoLoop(videoElement, vid, videoNum) {
        if (this.state.play) {
            //videoElement.play();
            videoElement.videoNum = videoNum;
            var self = this;
            videoElement.onended = function () {
                //videoElement.pause();
                //videoElement.src = vid;
                videoElement.play();
                if (this.num == 1) {
                    self.restartAll();
                }

            }.bind(this);
        }
    }

    restartAll() {
        switch (this.state.numVideos) {
            case 2:
                this.refs.video2.currentTime = 0;
                this.refs.video2.play();
                break;
            case 3:
                this.refs.video2.currentTime = 0;
                this.refs.video2.play();

                this.refs.video3.currentTime = 0;
                this.refs.video3.play();

                break;
            case 4:
                this.refs.video2.currentTime = 0;
                this.refs.video2.play();

                this.refs.video3.currentTime = 0;
                this.refs.video3.play();

                this.refs.video4.currentTime = 0;
                this.refs.video4.play();
                break;

            case 5:
                this.refs.video2.currentTime = 0;
                this.refs.video2.play();

                this.refs.video3.currentTime = 0;
                this.refs.video3.play();

                this.refs.video4.currentTime = 0;
                this.refs.video4.play();

                this.refs.video5.currentTime = 0;
                this.refs.video5.play();
                break;
        }
    }

    togglePlay(e) {
        e.preventDefault();

        var all = document.getElementsByTagName("video");
        for (var i = 0; i < all.length; i++) {
            all[i].pause();
            //all[i].outerHTML = "";
            //delete all[i];
        }


        this.setState({play: true}, function () {
            this.playVideos();
        });

    }

    render() {
        var w = window.innerWidth * 0.2;
        var cellStyle = {
            width: w,
            height: w
        }

        var h = {
            height: w
        }

        var bg1 = {}, bg2 = {}, bg3 = {}, bg4 = {}, bg5 = {};

        bg1 = {
            backgroundImage: "url(" + this.state.video1_image + ")"
        };

        if (this.state.video2_image) {
            bg2 = {
                backgroundImage: "url(" + this.state.video2_image + ")"
            };
        }

        if (this.state.video3_image) {
            bg3 = {
                backgroundImage: "url(" + this.state.video3_image + ")"
            };
        }

        if (this.state.video4_image) {
            bg4 = {
                backgroundImage: "url(" + this.state.video4_image + ")"
            };
        }

        if (this.state.video5_image) {
            bg5 = {
                backgroundImage: "url(" + this.state.video5_image + ")"
            };
        }

        var respond = <div className="full">
            <div className="table">
                <div className="table-cell">
                    <Link className="btn" to={"/record/" + this.state.id}>Respond</Link>
                </div>
            </div>
        </div>;

        if (!this.state.respond) {
            respond = null;
        }

        var video2HTML, video3HTML, video4HTML, video5HTML;

        var overlayWidth = {
            width: '100%'
        }
        if (this.state.video2 == null && this.state.video3 == null && this.state.video4 == null && this.state.video5 == null) {
            video2HTML = respond;
            video3HTML = <span></span>;
            video4HTML = <span></span>;
            video5HTML = <span></span>;

            overlayWidth = {
                width: '20%'
            }
        }

        if (this.state.video2 != null && this.state.video3 == null && this.state.video4 == null && this.state.video5 == null) {
            video3HTML = respond;
            video4HTML = <span></span>;
            overlayWidth = {
                width: '33.3333%'
            }
        }

        if (this.state.video2 != null && this.state.video3 != null && this.state.video4 == null && this.state.video5 == null) {
            video4HTML = respond;
            overlayWidth = {
                width: '50%'
            }
        }

        if (this.state.video2 != null && this.state.video3 != null && this.state.video4 != null && this.state.video5 == null) {
            video5HTML = respond;
            overlayWidth = {
                width: '75%'
            }
        }

        const videoGifStart = (e) => {
            const currentVideo = e.currentTarget;
            currentVideo.play()
        }

        const videoGifPause = (e) => {
            const currentVideo = e.currentTarget;
            currentVideo.pause()
        }

        return (
            <div className="quad">
                <div className="meta cf">
                    <div className="left">
                        <div className="pad">
                            <a href={"/d/" + this.state.id}>
                                <h3>{this.state.name}</h3>
                                {this.state.when ?
                                    <div className="date"><Moment fromNow>{this.state.when}</Moment></div> : null}
                            </a>
                        </div>
                    </div>
                    <div className="right">
                        <div className="pad social">

                            <a href={"https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent("https://dance2.me/d/" + this.state.id) + "&picture=" + encodeURIComponent(this.state.video1_image) + "&title=" + encodeURIComponent("Dance2Me - Check out my dance") + "&description=" + encodeURIComponent("Dance to Me is a collaborative experiment in social engagement and viewer interaction created by artists from different disciplines, Kharis Kennedy and Bryon Carr.")}
                               target="_blank"><img src="/img/fb-white.png"/></a>
                            <a href={"https://twitter.com/intent/tweet?text=" + encodeURIComponent("Check out my dance: https://dance2.me/d/" + this.state.id)}
                               target="_blank"><img src="/img/twitter-white.png"/></a>
                        </div>
                    </div>
                </div>
                <div className="videoHolder">
                    <div className={`videoCell ${this.state.video1 && 'videoCellPlay'}`} style={bg1}>
                        {this.state.video1 ?
                            <video
                                className="videoSquare"
                                onMouseEnter={(e) => videoGifStart(e)}
                                onMouseLeave={(e) => videoGifPause(e)}
                                ref="video1"
                                muted
                                src={this.state.video1}
                                onClick={() => this.setState({fullscreenVideo: this.state.video1})}
                            />
                            : null}
                    </div>

                    <div className={`videoCell ${this.state.video2 && 'videoCellPlay'}`} style={bg2}>
                        {this.state.video2 ?
                            <video
                                className="videoSquare"
                                onMouseEnter={(e) => videoGifStart(e)}
                                onMouseLeave={(e) => videoGifPause(e)}
                                ref="video2"
                                muted
                                src={this.state.video2}
                                onClick={() => this.setState({fullscreenVideo: this.state.video2})}                                
                            />
                            : video2HTML}
                    </div>

                    <div className={`videoCell ${this.state.video3 && 'videoCellPlay'}`} style={bg3}>
                        {this.state.video3 ?
                            <video
                                className="videoSquare"
                                onMouseEnter={(e) => videoGifStart(e)}
                                onMouseLeave={(e) => videoGifPause(e)}
                                ref="video3"
                                muted
                                src={this.state.video3}
                                onClick={() => this.setState({fullscreenVideo: this.state.video3})}                                
                            />
                            : video3HTML}
                    </div>

                    <div className={`videoCell ${this.state.video4 && 'videoCellPlay'}`} style={bg4}>
                        {this.state.video4 ?
                            <video
                                className="videoSquare"
                                onMouseEnter={(e) => videoGifStart(e)}
                                onMouseLeave={(e) => videoGifPause(e)}
                                ref="video4"
                                muted
                                src={this.state.video4}
                                onClick={() => this.setState({fullscreenVideo: this.state.video4})}                                
                            />
                            : video4HTML}
                    </div>

                    <div className={`videoCell ${this.state.video5 && 'videoCellPlay'}`} style={bg5}>
                        {this.state.video5 ?
                            <video
                                className="videoSquare"
                                onMouseEnter={(e) => videoGifStart(e)}
                                onMouseLeave={(e) => videoGifPause(e)}
                                ref="video5"
                                muted
                                src={this.state.video5}
                                onClick={() => this.setState({fullscreenVideo: this.state.video5})}                                
                            />
                            : video5HTML}
                    </div>

                </div>
                <div className="attrHolder cf">
                    <div className="attr">{this.state.video1_caption}</div>
                    <div className="attr">{this.state.video2_caption}</div>
                    <div className="attr">{this.state.video3_caption}</div>
                    <div className="attr">{this.state.video4_caption}</div>
                    <div className="attr">{this.state.video5_caption}</div>
                </div>
                {this.state.fullscreenVideo && (
                    <FullscreenView video={this.state.fullscreenVideo} onClose={() => this.setState({fullscreenVideo: null})}/>
                )}

            </div>
        )
    }
}

export default Dance;



// WEBPACK FOOTER //
// src/Dance.js